import React, {Component} from 'react';
// import { Link } from 'react-router';
// import ReactGA from 'react-ga';
// import data from '../../content/checklistContent.js';
import './Success.css';

export default class Success extends Component {

    componentDidMount() {
        this.props.rerender();
    }

    render() {
        return (
            <div className='page-container'>
                <div className='success'>
                    <img src='images/financial-health-tool.png' className='page-logo' alt='page-logo'/>

                    <h1 className="title page-title is-4 is-spaced">
                        Congratulations! Your startup is financially healthy.
                    </h1>

                    <p className='description'>
                        Knowing what to keep an eye on will enable your small business to grow and succeed, which is what NorthOne is all about! If you found this tool help and are looking for other helpful tools, we’d love to invite you to join <a href='https://www.northone.io' target='_blank'><ins>our waitlist</ins></a> so we can share other helpful tools that will empower your business!
                    </p>

                    <br/>
                    <a href='https://www.northone.io/community?utm_source=checklist' target='_blank'>
                        <button>
                            GET MORE TOOLS
                        </button>
                    </a>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/pages/Success.js